var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AngularFireAuth } from '@angular/fire/auth';
import { FirestoreService } from 'common-lib';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "common-lib";
import * as i2 from "@angular/fire/auth";
export class UserService {
    constructor(fire, auth) {
        this.fire = fire;
        this.auth = auth;
        auth.user.subscribe((user) => {
            this.currentUser = user;
        });
    }
    getProfile() {
        return __awaiter(this, void 0, void 0, function* () {
            const user = this.currentUser;
            if (!user || user.isAnonymous) {
                return null;
            }
            try {
                const profile = yield this.fire.doc(`profiles/${user.uid}`).get().toPromise();
                if (profile.exists) {
                    return Object.assign({}, profile.data(), { email: this.auth.auth.currentUser.email });
                }
                else {
                    return null;
                }
            }
            catch (e) {
                console.log(e);
                return null;
            }
        });
    }
    isValidProfile() {
        return __awaiter(this, void 0, void 0, function* () {
            const profile = yield this.getProfile();
            if (!profile) {
                return false;
            }
            return (!!profile.email && !!profile.companyPost && !!profile.industry && !!profile.jobType && !!profile.annualIncome);
        });
    }
    didEntryJob$(jobId) {
        const user = this.currentUser;
        if (!user) {
            return new Observable((sub) => {
                sub.next(false);
            });
        }
        return this.fire
            .col$(`profiles/${user.uid}/entries`, (ref) => ref.where('job', '==', this.fire.doc(`jobs/${jobId}`).ref))
            .pipe(map((doc) => {
            if (doc && doc.length > 0) {
                return true;
            }
            return false;
        }));
    }
}
UserService.ngInjectableDef = i0.defineInjectable({ factory: function UserService_Factory() { return new UserService(i0.inject(i1.FirestoreService), i0.inject(i2.AngularFireAuth)); }, token: UserService, providedIn: "root" });
